const GenomeList=[
    {
        label:"AmericanLotus2022",
        value:"AmericanLotus2022"
    },
    {
        label:"NLU",
        value:"AmericanLotus2024"
    },
    {
        label:"NNU",
        value:"AsianLotus"
    },
]
export default GenomeList